import { AxiosResponse } from 'axios';
import { IClient, IOkResponse, PaginatedType } from '@types';
import {
    IClientFavoriteProduct,
    IClientsQuery,
    ITopStats,
} from '@entities/client/model/types';
import { api, API_URL } from '@api/config';

const BASE_PATH = 'shops';

export const getClientsRequest = (
    shop_id: number,
    params: IClientsQuery
): Promise<AxiosResponse<PaginatedType<IClient>>> => {
    return api.get<PaginatedType<IClient>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/list`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getTopStatsRequest = (
    period: string,
    shop_id: number
): Promise<AxiosResponse<ITopStats>> => {
    return api.get<ITopStats>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/topStats`,
        {
            params: {
                period,
            },
        }
    );
};

export const blockClientRequest = async (
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IOkResponse, React.Key>> => {
    return await api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/block`
    );
};

export const unBlockClientRequest = (
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IOkResponse, React.Key>> => {
    return api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/unblock`
    );
};

export const deleteClientRequest = (
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IOkResponse, React.Key>> => {
    return api.delete<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}`
    );
};

export const getClientRequest = (
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IClient, React.Key>> => {
    return api.get<IClient>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}`
    );
};

export const getClientsFavoriteProductsRequest = (
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IClientFavoriteProduct[], React.Key>> => {
    return api.get<IClientFavoriteProduct[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/favorite-products`
    );
};
export const updateClientCommentRequest = (
    text: string,
    id: React.Key,
    shop_id: number
): Promise<AxiosResponse<IClient, React.Key>> => {
    return api.post<IClient>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/comment`,
        { text }
    );
};
